module.exports = __webpack_public_path__ + "img/bf-yel.c3e396fb.png";